import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import Global from '../../store/global-selectors';

import { WeightInput } from 'ui-components/components/weight-input';

const OrderFilterWeightInput = ({ onChange, weight = 0 }) => {
  const sellerUnit = useSelector(Global.selectSellerDefaultWeightUnit);

  const onValueChange = useCallback(
    (w) => {
      onChange(w, sellerUnit);
    },
    [onChange, sellerUnit],
  );

  return <WeightInput onChange={onValueChange} unit={sellerUnit} weight={weight} />;
};

OrderFilterWeightInput.propTypes = {
  weight: PropTypes.number,
  onChange: PropTypes.func.isRequired,
};

export default OrderFilterWeightInput;
